import { render, staticRenderFns } from "./notification-NextValidationFlowTaskNotification.vue?vue&type=template&id=20523f80&scoped=true"
import script from "./notification-NextValidationFlowTaskNotification.vue?vue&type=script&lang=js"
export * from "./notification-NextValidationFlowTaskNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20523f80",
  null
  
)

export default component.exports